var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-page-primary"},[_c('div',{staticClass:"container-403"},[_vm._m(0),_c('p',[_vm._v("Access denied")]),_c('router-link',{attrs:{"to":"/welcome"}},[_c('p',[_vm._v("Back To Main Page")])])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v(" 4 "),_c('div',{staticClass:"lock"},[_c('div',{staticClass:"top"}),_c('div',{staticClass:"bottom"})]),_vm._v(" 3 ")])
}]

export { render, staticRenderFns }